export enum ApiTokenCodes {
  TokenExpired = 'token_expired',
  InvalidToken = 'invalid_token',
  InvalidScope = 'invalid_scope',
  TokenRevoked = 'token_revoked',
  TokenUnknown = 'token_unknown',
  UserTemporaryBlocked = 'user_temporary_blocked',
}

export enum ApiUnavailableReasonCodes {
  NoActiveRoomsToBook = 'no_active_rooms_to_book',
  InclBreakfastOptionUnavailable = 'incl_breakfast_option_unavailable',
  BookingPeriodUnavailable = 'booking_period_unavailable',
  GuestsNumberOptionUnavailable = 'guests_number_option_unavailable',
}
